const actions = {
  SET_STATE: 'schools/SET_STATE',
  GET_DATA: 'schools/GET_DATA',
}

export default actions
